var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',[_c('hero-section'),_c('hoe-section'),_c('ErSection'),_c('start-section')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }